"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLATFORMS = exports.PlatformCodeEnum = void 0;
var PlatformCodeEnum;
(function (PlatformCodeEnum) {
    PlatformCodeEnum["API"] = "KP001";
    PlatformCodeEnum["KUSHKIJS"] = "KP002";
    PlatformCodeEnum["ANDROID"] = "KP003";
    PlatformCodeEnum["IOS"] = "KP004";
    PlatformCodeEnum["SMARTLINKS"] = "KP005";
    PlatformCodeEnum["KAJITA"] = "KP006";
    PlatformCodeEnum["CAJITA"] = "KP007";
    PlatformCodeEnum["VTEX"] = "KP008";
    PlatformCodeEnum["MAGENTO"] = "KP009";
    PlatformCodeEnum["PRESTASHOP"] = "KP010";
    PlatformCodeEnum["WOOCOMERCE"] = "KP011";
    PlatformCodeEnum["SHOPIFY"] = "KP012";
    PlatformCodeEnum["WEBCHECKOUT"] = "KP013";
    PlatformCodeEnum["EXPRESS_CHECKOUT"] = "KP014";
})(PlatformCodeEnum = exports.PlatformCodeEnum || (exports.PlatformCodeEnum = {}));
exports.PLATFORMS = {
    KP001: {
        platformId: "KP001",
        platformName: "API",
    },
    KP002: {
        platformId: "KP002",
        platformName: "KUSHKIJS",
    },
    KP003: {
        platformId: "KP003",
        platformName: "ANDROID",
    },
    KP004: {
        platformId: "KP004",
        platformName: "IOS",
    },
    KP005: {
        platformId: "KP005",
        platformName: "SMARTLINKS",
    },
    KP006: {
        platformId: "KP006",
        platformName: "KAJITA",
    },
    KP007: {
        platformId: "KP007",
        platformName: "CAJITA",
    },
    KP008: {
        platformId: "KP008",
        platformName: "VTEX",
    },
    KP009: {
        platformId: "KP009",
        platformName: "MAGENTO",
    },
    KP010: {
        platformId: "KP010",
        platformName: "PRESTASHOP",
    },
    KP011: {
        platformId: "KP011",
        platformName: "WOOCOMERCE",
    },
    KP012: {
        platformId: "KP012",
        platformName: "SHOPIFY",
    },
    KP013: {
        platformId: "KP013",
        platformName: "WEBCHECKOUT",
    },
    KP014: {
        platformId: "KP014",
        platformName: "EXPRESS_CHECKOUT",
    },
};
